"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultAddress = void 0;

var _ethers = require("ethers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const ethers = _objectSpread({}, _ethers.ethers);

if (ethers.version.startsWith("6.")) {
  ethers.constants = {
    AddressZero: ethers === null || ethers === void 0 ? void 0 : ethers.ZeroAddress
  };
}

const defaultAddress = {
  Zero: ethers.constants.AddressZero,
  Burn: "0x000000000000000000000000000000000000dEaD"
};
exports.defaultAddress = defaultAddress;